import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Me, ClearMe } from '../store/user/user.actions';
import { BotService } from './bot.service';
import { PortalService } from './portal.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private store: Store,
    private botService: BotService
  ) { }

  static getAccessToken(): string {
    const authData: any = JSON.parse(
      localStorage.getItem('ngStorage-authData') || JSON.stringify(null)
    );
    return authData && authData.access_token ? authData.access_token : '';
  }

  static isAuthenticated(): string {
    const authData: any = JSON.parse(
      localStorage.getItem('ngStorage-authData') || JSON.stringify(null)
    );
    return authData && authData.access_token;
  }

  login(email: string, password: string): Observable<any> {
    return this.http.post(PortalService.ApiUrl + '/user/login', {
      email: email,
      password: password
    });
  }

  register(email: string, password: string, first_name: string, last_name: string): Observable<any> {
    return this.http.post(PortalService.ApiUrl + '/user/registration', {
      email: email,
      password: password,
      first_name: first_name,
      last_name: last_name,
      portal_id: PortalService.Settings.portal_id
    });
  }

  loginByToken(token: string): void {
    if (token) {
      this.http
        .get<any>(PortalService.ApiUrl + '/tfid/login/' + token)
        .subscribe((response) => {
          if (response.status) {
            localStorage.setItem(
              'ngStorage-authData',
              JSON.stringify(response.data)
            );
            this.store.dispatch(new Me());
            this.botService.getBots().subscribe((result) => {
              if (result.total == 0) {
                this.router.navigate(['/wizard/general']);
              } else {
                this.router.navigate([
                  '/bot/' + result.bots[0].bot_id + '/wizard/general',
                ]);
              }
            });
          }
        });
    }
  }

  logout(): void {
    localStorage.removeItem('ngStorage-authData');
    this.store.dispatch(new ClearMe());
    this.router.navigate(['/']);
  }

  static getAccountId(): string {
    const authData: any = JSON.parse(
      localStorage.getItem('ngStorage-authData') || JSON.stringify(null)
    );
    return authData && authData.account_id ? authData.account_id : '';
  }
}
